import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Card, CardContent, Link, Typography } from "@mui/material";

import theme from "../../../theme";
import KPTextform from "../../../components/KPTComponents/KPTextform";
import KPTextfield from "../../../components/KPTComponents/KPTextfield";

import { KPTYPE } from "../../../components/KPTComponents/KPTextform/KPTextform";
import { crudActions, userActions } from "../../../actions";
import {
  FORM_CONSTANTS,
  FORM_MODEL,
  FORM_MODEL_DANH_GIA,
  PROFILE_MODEL,
  USER_CONSTANTS,
} from "../../../constants";
import { useParams } from "react-router-dom";
import { convertDoiLink } from "../../../utils";

const mucBSub = {
  foreignLanguageTrainingAbroad: (values = null) => [
    {
      key: "foreignLanguageTrainingAbroad.hocDaiHoc",
      xs: 12,
      label: "Học đại học",
      labelRender: <></>,
      type: KPTYPE.checkbox,
    },
    {
      key: "foreignLanguageTrainingAbroad.noiHocDH",
      xs: 6,
      label: "Tại nước",
      disabled: !values.foreignLanguageTrainingAbroad.hocDaiHoc,
    },
    {
      key: "foreignLanguageTrainingAbroad.namBDHocDH",
      xs: 3,
      label: "Từ năm",
      disabled: !values.foreignLanguageTrainingAbroad.hocDaiHoc,
    },
    {
      key: "foreignLanguageTrainingAbroad.namKTHocDH",
      xs: 3,
      label: "Đến năm",
      disabled: !values.foreignLanguageTrainingAbroad.hocDaiHoc,
    },
    {
      key: "foreignLanguageTrainingAbroad.baoVe",
      xs: 4,
      label: "Bảo vệ",
      type: KPTYPE.select,
      options: [
        { key: "null", title: "-", value: null },
        { key: "ths", title: "Luận văn ThS", value: "ths" },
        { key: "ts", title: "Luận án TS", value: "ts" },
        { key: "tskh", title: "TSKH", value: "tskh" },
      ],
    },
    {
      key: "foreignLanguageTrainingAbroad.noiBVLuanVan",
      xs: 5,
      label: "Tại nước",
      disabled: !values.foreignLanguageTrainingAbroad.baoVe,
    },
    {
      key: "foreignLanguageTrainingAbroad.namBVLuanVan",
      xs: 3,
      label: "Năm",
      disabled: !values.foreignLanguageTrainingAbroad.baoVe,
    },
  ],
  foreignLanguageTrainingInland: (values = null) => [
    {
      key: "foreignLanguageTrainingInland.truongCapBangDH",
      xs: 12,
      label: "Trường ĐH cấp bằng tốt nghiệp ĐH ngoại ngữ",
      required: true,
    },
    {
      key: "foreignLanguageTrainingInland.soHieuBang",
      xs: 6,
      label: "Số bằng",
      required: true,
    },
    {
      key: "foreignLanguageTrainingInland.namCapBang",
      xs: 6,
      label: "Ngày cấp",
      type: KPTYPE.date,
      required: true,
    },
  ],
  teachingInForeignLanguage: (values = null) => [
    {
      key: "teachingInForeignLanguage.ngoaiNguGiangDay",
      xs: 12,
      label: "Giảng dạy bằng ngoại ngữ",
      required: true,
    },
    {
      key: "teachingInForeignLanguage.noiGiangDay",
      xs: 12,
      label: "Nơi giảng dạy (cơ sở đào tạo, nước)",
      type: KPTYPE.textarea,
      height: 1,
      required: true,
    },
  ],
};

export const textFormDanhGia = {
  mucA0: [
    { ...FORM_MODEL_DANH_GIA.giangVien, xs: 12 },
    { ...FORM_MODEL_DANH_GIA.giangVienThinhGiang, xs: 12 },
  ],
  mucA9: [{ ...FORM_MODEL_DANH_GIA.thoiGianDaoTao, xs: 12 }],
  mucB1: [
    {
      ...FORM_MODEL_DANH_GIA.tieuChuanNhiemVuNhaGiao,
      key: "tieuChuanNhaGiao",
      label: "Về tiêu chuẩn nhà giáo",
      required: true,
      xs: 12,
    },
    {
      key: "tieuChuanKhongDu",
      label: "Những tiêu chuẩn không đủ",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
    {
      ...FORM_MODEL_DANH_GIA.tieuChuanNhiemVuNhaGiao,
      key: "nhiemVuNhaGiao",
      label: "Về nhiệm vụ nhà giáo",
      required: true,
      xs: 12,
    },
    {
      key: "nhiemVuKhongDu",
      label: "Những nhiệm vụ không đủ",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
  ],
  mucB3: [
    {
      ...FORM_MODEL_DANH_GIA.ngoaiNgu,
      key: "ngoaiNguThanhThao",
      label: "Ngoại ngữ thành thạo",
      required: true,
      xs: 6,
    },
    {
      ...FORM_MODEL_DANH_GIA.ngoaiNgu,
      key: "giaoTiepTiengAnh",
      label: "Giao tiếp tiếng Anh",
      required: true,
      xs: 6,
    },
  ],
  mucC: [
    {
      key: "uuNhuocDiemBCKH",
      label: "Ưu/nhược điểm của BCKH tổng quan",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
    {
      key: "vanDeCanLamRo",
      label: "Những vấn đề ứng viên cần làm rõ khi trình bày BCKH tổng quan",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
    {
      ...FORM_MODEL_DANH_GIA.ketLuanChung,
      xs: 12,
      key: "ketLuanChung",
      label: "Kết luận chung",
      required: true,
    },
  ],
  mucNhanXet: [
    {
      key: "uuDiem",
      label: "Ưu điểm",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
    {
      key: "nhuocDiem",
      label: "Nhược điểm",
      type: KPTYPE.richtext,
      // required: true,
      xs: 12,
    },
    {
      key: "danhGiaChung",
      label: "Đánh giá chung",
      type: KPTYPE.richtext,
      required: true,
      xs: 12,
    },
  ],
};

export const textForm = {
  mucA0: [
    { ...FORM_MODEL.category, xs: 12 },
    { ...FORM_MODEL.entity, xs: 12 },
    { ...FORM_MODEL.major, xs: 12 },
    {
      ...FORM_MODEL.specialization,
      type: KPTYPE.render,
      xs: 12,
      labelRender: <></>,
      render: ({ values, error, handleChangeForm }) => (
        <KPTextfield
          error={error}
          id="specialization"
          key="specialization"
          label="Ngành chuyên sâu"
          type={KPTYPE.select}
          value={values.specialization || ""}
          options={FORM_CONSTANTS.SPECIALIZATION_OPTIONS[values.major] || []}
          handleChangeForm={handleChangeForm}
        />
      ),
    },
  ],
  mucA: {
    muc1_6: [
      { ...PROFILE_MODEL.name, xs: 8 },
      { ...PROFILE_MODEL.birth, xs: 4 },
      {
        key: "noti",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: () => (
          <Typography
            variant="subtitle1"
            style={{ color: theme.palette.info.main }}
          >
            <i>(Viết bằng Tiếng Việt có dấu, không viết hoa toàn bộ tên)</i>
          </Typography>
        ),
      },
      { ...PROFILE_MODEL.gender, xs: 3 },
      { ...PROFILE_MODEL.nation, xs: 3 },
      { ...PROFILE_MODEL.ethnic, xs: 3 },
      { ...PROFILE_MODEL.religion, xs: 3 },
      { ...PROFILE_MODEL.isPartyMember, xs: 12 },
      {
        key: "notixx",
        xs: 12,
        type: KPTYPE.render,
        render: () => null,
        label: "4. Quê quán",
      },
      { ...PROFILE_MODEL.commune, xs: 4 },
      { ...PROFILE_MODEL.district, xs: 4 },
      { ...PROFILE_MODEL.province, xs: 4 },
      { ...PROFILE_MODEL.placeOfResidence, xs: 12 },
      { ...PROFILE_MODEL.contactAddress, xs: 12 },
      { ...PROFILE_MODEL.address, xs: 12 },
      { ...PROFILE_MODEL.phone, xs: 12 },
      { ...PROFILE_MODEL.email, xs: 12, disabled: true },
    ],
    muc7: [
      { ...FORM_MODEL.pastWorkingProcessStartTime, xs: 5 },
      {
        key: "to_0",
        xs: 2,
        labelRender: <Box sx={{ marginTop: "25.5px" }} />,
        type: KPTYPE.render,
        render: (props) => (
          <Box
            sx={{
              height: 39,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography className="kpt-textfield-label">đến</Typography>
          </Box>
        ),
      },
      {
        ...FORM_MODEL.pastWorkingProcessEndTime,
        xs: 5,
        labelRender: <Box sx={{ marginTop: "25.5px" }} />,
      },
      { ...FORM_MODEL.pastWorkingProcessUnit, xs: 12 },
      { ...FORM_MODEL.pastWorkingProcessUnitAddress, xs: 12 },
      { ...FORM_MODEL.pastWorkingProcessPosition, xs: 12 },
    ],
    muc8: [
      {
        ...FORM_MODEL.currentWorkingProcessPosition,
        xs: 12,
        label: "Chức vụ hiện nay",
        required: true,
      },
      {
        key: "noti_0",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: () => (
          <Typography
            variant="subtitle1"
            style={{ color: theme.palette.info.main }}
          >
            <i>
              (Nếu đã nghỉ hưu, điền <b>Không có</b>)
            </i>
          </Typography>
        ),
      },
      { ...FORM_MODEL.currentWorkingProcessHighestPosition, xs: 12 },
      { ...FORM_MODEL.currentWorkingProcessUnit, xs: 12, md: 8 },
      { ...FORM_MODEL.currentWorkingProcessUnitPhone, xs: 12, md: 4 },
      { ...FORM_MODEL.currentWorkingProcessUnitAddress, xs: 12 },
      { ...FORM_MODEL.currentWorkingProcessUniversity, xs: 12 },
      { ...FORM_MODEL.currentWorkingProcessRetireTime, xs: 12 },
      { ...FORM_MODEL.currentWorkingProcessRetireUnit, xs: 12 },
      { ...FORM_MODEL.lastThreeYearUniversity, xs: 12 },
    ],
    muc10_13: [
      { ...FORM_MODEL.pgsStartTime, xs: 7 },
      { ...FORM_MODEL.pgsMajor, xs: 5 },
      { ...FORM_MODEL.scientificCouncil, xs: 12 },
      { ...FORM_MODEL.registeredMajor, xs: 12, disabled: true },
    ],
  },
  mucB: {
    muc1: [{ ...FORM_MODEL.selfAssessment, xs: 12 }],
    muc2: [
      { ...FORM_MODEL.totalEducateYear, xs: 6 },
      { ...FORM_MODEL.totalEducateMonth, xs: 6 },
    ],
    muc3: [
      { ...FORM_MODEL.foreignLanguage, xs: 7 },
      {
        ...FORM_MODEL.otherForeignLanguage,
        xs: 5,
        type: KPTYPE.render,
        labelRender: <></>,
        required: true,
        render: ({ values, error, handleChangeForm }) => (
          <KPTextfield
            error={error}
            id="otherForeignLanguage"
            key="otherForeignLanguage"
            label="Ngoại ngữ khác"
            value={values.otherForeignLanguage || ""}
            disabled={values.foreignLanguage !== "other"}
            required={values.foreignLanguage === "other"}
            handleChangeForm={handleChangeForm}
          />
        ),
      },
      {
        key: "noti_muc3",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: () => (
          <Typography
            variant="subtitle1"
            style={{ color: theme.palette.info.main }}
          >
            <i>
              (<b>Lưu ý:</b> trường hợp ứng viên thành thạo nhiều hơn 1 ngoại
              ngữ thì chọn "Ngôn ngữ khác" và khai báo đầy đủ vào ô Ngoại ngữ
              khác)
            </i>
          </Typography>
        ),
      },
      {
        key: "foreignLanguageTrainingAbroad.selected",
        xs: 12,
        label: "a) Được đào tạo ở nước ngoài",
        labelRender: <></>,
        type: KPTYPE.checkbox,
      },
      {
        key: "foreignLanguageTrainingAbroadSub",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: ({ values, error, handleChangeForm }) => (
          <Fragment>
            {values.foreignLanguageTrainingAbroad?.selected && (
              <Card>
                <CardContent>
                  <KPTextform
                    component={Box}
                    error={error}
                    values={values}
                    textForm={mucBSub.foreignLanguageTrainingAbroad(values)}
                    handleChangeForm={handleChangeForm}
                  />
                </CardContent>
              </Card>
            )}
          </Fragment>
        ),
      },
      {
        key: "foreignLanguageTrainingInland.selected",
        xs: 12,
        label: "b) Được đào tạo ngoại ngữ trong nước",
        labelRender: <></>,
        type: KPTYPE.checkbox,
      },
      {
        key: "foreignLanguageTrainingInlandSub",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: ({ values, error, handleChangeForm }) => (
          <Fragment>
            {values.foreignLanguageTrainingInland?.selected && (
              <Card>
                <CardContent>
                  <KPTextform
                    component={Box}
                    error={error}
                    values={values}
                    textForm={mucBSub.foreignLanguageTrainingInland(values)}
                    handleChangeForm={handleChangeForm}
                  />
                </CardContent>
              </Card>
            )}
          </Fragment>
        ),
      },
      {
        key: "teachingInForeignLanguage.selected",
        xs: 12,
        label: "c) Giảng dạy bằng tiếng nước ngoài",
        labelRender: <></>,
        type: KPTYPE.checkbox,
      },
      {
        key: "teachingInForeignLanguageSub",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: ({ values, error, handleChangeForm }) => (
          <Fragment>
            {values.teachingInForeignLanguage?.selected && (
              <Card>
                <CardContent>
                  <KPTextform
                    component={Box}
                    error={error}
                    values={values}
                    textForm={mucBSub.teachingInForeignLanguage(values)}
                    handleChangeForm={handleChangeForm}
                  />
                </CardContent>
              </Card>
            )}
          </Fragment>
        ),
      },
      {
        key: "otherObject.selected",
        xs: 12,
        label: "d) Đối tượng khác",
        labelRender: <></>,
        type: KPTYPE.checkbox,
      },
      {
        key: "otherObjectSub",
        xs: 12,
        type: KPTYPE.render,
        labelRender: <></>,
        render: ({ values, error, handleChangeForm }) => (
          <Fragment>
            {values.otherObject?.selected && (
              <Card>
                <CardContent>
                  <KPTextform
                    component={Box}
                    error={error}
                    values={values}
                    textForm={[
                      {
                        key: "otherObject.dienGiai",
                        xs: 12,
                        label: "Diễn giải",
                        required: true,
                      },
                    ]}
                    handleChangeForm={handleChangeForm}
                  />
                </CardContent>
              </Card>
            )}
          </Fragment>
        ),
      },
      { ...FORM_MODEL.englishCertificate, xs: 12 },
      {
        ...FORM_MODEL.foreignLanguageDegreeCertificate,
        xs: 12,
        labelRender: <></>,
      },
    ],
    muc9: [
      {
        key: "remainingPGSTime",
        xs: 12,
        label: "a) Thời gian được bổ nhiệm PGS",
        type: KPTYPE.render,
        render: () => (
          <Typography className="kpt-textfield-label" variant="subtitle1">
            Được bổ nhiệm PGS chưa đủ 3 năm, thiếu (số lượng năm, tháng)
          </Typography>
        ),
      },
      {
        key: "remainingPGSTime.year",
        xs: 6,
        type: KPTYPE.int,
        label: "Số lượng năm",
      },
      {
        key: "remainingPGSTime.month",
        xs: 6,
        type: KPTYPE.int,
        label: "Số lượng tháng",
      },
      {
        key: "remainingEducateTime",
        xs: 12,
        label: "b) Hoạt động đào tạo",
        type: KPTYPE.render,
        render: () => (
          <Typography className="kpt-textfield-label" variant="subtitle1">
            Thâm niên đào tạo chưa đủ 6 năm (ƯV PGS), còn thiếu (số lượng năm,
            tháng)
          </Typography>
        ),
      },
      {
        key: "remainingDirectTeachingTime.year",
        xs: 6,
        type: KPTYPE.int,
        label: "Số lượng năm",
      },
      {
        key: "remainingConvertedTeachingTime.month",
        xs: 6,
        type: KPTYPE.int,
        label: "Số lượng tháng",
      },
      {
        key: "remainingEducateTime-noti",
        xs: 12,
        label: "Giờ giảng dạy",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "remainingEducateTime.direct",
        xs: 12,
        label:
          "Giờ chuẩn giảng dạy trực tiếp trên lớp không đủ, còn thiếu (năm học/số giờ thiếu)",
      },
      {
        key: "remainingEducateTime.convert",
        xs: 12,
        label:
          "Giờ chuẩn giảng dạy quy đổi không đủ, còn thiếu (năm học/số giờ thiếu)",
      },
      {
        key: "otherInfoB9_1",
        xs: 12,
        label: "Hướng dẫn chính NCS/HVCH,CK2/BSNT",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.dhdNcsGs",
        xs: 12,
        labelRender: false,
        label:
          "Đã hướng dẫn chính 01 NCS đã có Quyết định cấp bằng TS (ƯV chức danh GS)",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuGs",
        xs: 12,
        label:
          "Đề xuất CTKH để thay thế tiêu chuẩn hướng dẫn 01 NCS được cấp bằng TS bị thiếu",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9.dhdNcsPgs",
        xs: 12,
        labelRender: false,
        label:
          "Đã hướng dẫn chính 01 HVCH/CK2/BSNT đã có Quyết định cấp bằng ThS/CK2/BSNT (ƯV chức danh PGS)",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuPgs",
        xs: 12,
        label:
          "Đề xuất CTKH để thay thế tiêu chuẩn hướng dẫn 01 HVCH/CK2/BSNT được cấp bằng ThS/CK2/BSNT bị thiếu",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9_2",
        xs: 12,
        label: "c) Nghiên cứu khoa học",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.nhiemVuCapBo",
        xs: 12,
        labelRender: false,
        label: "Đã chủ trì 01 nhiệm vụ KH&CN cấp Bộ (ƯV chức danh GS)",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuGsCapBo",
        xs: 12,
        label:
          "Đề xuất CTKH để thay thế tiêu chuẩn chủ trì 01 nhiệm vụ KH&CN cấp Bộ bị thiếu",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9.nhiemVuCapCoSo",
        xs: 12,
        labelRender: false,
        label: "Đã chủ trì 01 nhiệm vụ KH&CN cấp cơ sở (ƯV chức danh PGS)",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuPgsCapCoSo",
        xs: 12,
        label:
          "Đề xuất CTKH để thay thế tiêu chuẩn chủ trì 01 nhiệm vụ KH&CN cấp cơ sở bị thiếu",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9.nhiemVuKhac",
        xs: 12,
        label:
          "Không đủ số CTKH là tác giả chính sau khi được bổ nhiệm PGS hoặc được cấp bằng TS",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.nhiemVuKhacGs",
        xs: 12,
        label: "Đối với ứng viên chức danh GS, đã công bố được",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.nhiemVuKhacGs3",
        xs: 12,
        labelRender: false,
        label: "03 CTKH",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.nhiemVuKhacGs4",
        xs: 12,
        labelRender: false,
        label: "04 CTKH",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuGsSach",
        xs: 12,
        label:
          "Đề xuất sách CKUT/chương sách của NXB có uy tín trên thế giới là tác giả chính thay thế cho việc ƯV không đủ 05 CTKH là tác giả chính theo quy định",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9_3",
        xs: 12,
        label: "Đối với ứng viên chức danh PGS, đã công bố được",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.nhiemVuKhacPgs2",
        xs: 12,
        labelRender: false,
        label: "02 CTKH",
        type: KPTYPE.checkbox,
      },
      {
        key: "otherInfoB9.deXuatBiThieuPgsSach",
        xs: 12,
        label:
          "Đề xuất sách CKUT/chương sách NXB có uy tín trên thế giới là tác giả chính thay thế cho việc ƯV không đủ 03 CTKH là tác giả chính theo quy định",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9_4",
        xs: 12,
        label: "d) Biên soạn sách phục vụ đào tạo (đối với ứng viên GS)",
        type: KPTYPE.render,
        render: () => null,
      },
      {
        key: "otherInfoB9.bienSoanSach",
        xs: 12,
        label: "Không đủ điểm biên soạn sách phục vụ đào tạo",
        type: KPTYPE.text,
      },
      {
        key: "otherInfoB9.bienSoanSachChuyenKhao",
        xs: 12,
        label: "Không đủ điểm biên soạn giáo trình và sách chuyên khảo",
        type: KPTYPE.text,
      },
      // { key: 'remainingDirectTeachingTime', xs: 12, label: '+ Giờ chuẩn giảng dạy trực tiếp trên lớp không đủ, còn thiếu (năm học/số giờ thiếu)', type: KPTYPE.render, render: () => null, },
      // { key: 'remainingDirectTeachingTime.month', xs: 6, label: 'Số lượng tháng' },
      // { key: 'remainingConvertedTeachingTime', xs: 12, label: '+ Giờ chuẩn giảng dạy quy đổi không đủ, còn thiếu (năm học/số giờ thiếu)', type: KPTYPE.render, render: () => null, },
      // { key: 'remainingConvertedTeachingTime.year', xs: 6, label: 'Số lượng năm' },
    ],
  },
  mucC: [
    { ...FORM_MODEL.generalScientificReportProof, xs: 12, labelRender: <></> },
  ],
  mucE: [
    {
      ...FORM_MODEL.trainingAndScientificResearchProof,
      xs: 12,
      labelRender: <></>,
    },
  ],
};

export const ActionColumn = ({
  row,
  type,
  setDialog,
  filterType,
  setDuyetThanhTich,
  setPreview,
  setDeleteCrud,
  setChoDiem,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const _doi = convertDoiLink(row.doi);

  const profile = useSelector((state) => state.profileReducer.profile);

  return (
    <Box>
      {(_doi || row.proof) && (
        <Link
          variant="body2"
          className="action-btn"
          onClick={() => {
            if (typeof (_doi || row.proof) === "string") {
              window.open(_doi || row.proof, "_blank");
            } else if (Array.isArray(_doi || row.proof)) {
              if ((_doi || row.proof).length > 0) {
                setPreview(_doi || row.proof);
              } else {
                dispatch(
                  userActions.notification({
                    message: "Không có minh chứng",
                    type: "info",
                  })
                );
              }
            }
          }}
          style={{ display: "block" }}
        >
          {_doi?.includes("doi") ? "Link DOI" : "Minh chứng"}
        </Link>
      )}
      <Link
        variant="body2"
        className="action-btn"
        color="primary"
        style={{ display: "block", cursor: "pointer" }}
        onClick={() => {
          setDialog({ type, filterType, defaultValues: row });
        }}
      >
        Chi tiết
      </Link>
      {setDuyetThanhTich ? (
        <>
          <Link
            className="action-btn"
            color={
              row.scoringTable?.accepted
                ? theme.palette.error.main
                : theme.palette.primary.main
            }
            style={{ display: "block", cursor: "pointer" }}
            display={row?.notEligible ? "none" : "block"}
            onClick={() => {
              if (row?.notEligible) {
                dispatch(
                  userActions.notification({
                    message: "Không thể cho điểm khi không đủ điều kiện",
                    type: "warning",
                  })
                );
                return;
              }
              setDuyetThanhTich(row);
            }}
          >
            {row.scoringTable?.accepted ? "Hủy cho điểm" : "Cho điểm"}
          </Link>
          <Link
            className="action-btn"
            color={
              row?.notEligible
                ? theme.palette.error.main
                : theme.palette.primary.main
            }
            style={{ display: "block", cursor: "pointer" }}
            onClick={() => {
              setChoDiem(row);
            }}
          >
            {row.notEligible ? "Hủy không công nhận" : "Không công nhận"}
          </Link>
        </>
      ) : (
        <>
          {!id && (
            <Link
              color="error"
              className="action-btn"
              style={{ display: "block", cursor: "pointer" }}
              onClick={(e) => {
                setDeleteCrud({
                  type,
                  anchorEl: e.currentTarget,
                  handleDelete: () => {
                   if (profile?.submittable === false && profile?.userRole === USER_CONSTANTS.ROLE.candidate) {
                      // props.handleClose();
                      dispatch(userActions.notification({ message: 'Đã hết thời gian nộp hồ sơ', type: 'warning' }));
                      return;
                    }
                    dispatch(crudActions.remove(type, row?.id));
                  }
                });
              }}
            >
              Xóa
            </Link>
          )}
        </>
      )}
    </Box>
  );
};
